import { styled } from '@mui/joy';
import BaseTable, { TableProps } from '@mui/joy/Table';

export const TableContainer = styled('div')(() => ({
  display: 'flex',
  gap: '32px',
  paddingBottom: '64px',
  alignItems: 'flex-start',
  paddingRight: '4px',
  width: '100%',
}));
export const TableFilterTitle = styled('div')(({ theme: { typography } }) => typography['section-title']);
export const TableFilterHeader = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  marginTop: '28px',
  marginBottom: '12px',
}));
export const TableFilterContainer = styled('aside')(() => ({
  width: '276px',
  flexShrink: 0,
  padding: '24px',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  borderRadius: '3px',
}));

const BaseTableWithDefaults = (props: TableProps) => <BaseTable borderAxis="none" {...props} />;

export const Table = styled(BaseTableWithDefaults)(() => ({
  width: '100%',
  tableLayout: 'auto',
  minWidth: '800px',
  maxWidth: '1240px',
  borderCollapse: 'separate',
  borderSpacing: '0 4px',
}));

export const TableHead = styled('thead')(() => ({}));
export const TableHeaderRow = styled('tr')(() => ({}));
export const TableHeaderCell = styled('th')(({ theme }) => ({
  height: '52px !important',
  paddingLeft: '12px !important',
  paddingRight: '12px !important',
  paddingTop: '8px !important',
  paddingBottom: '8px !important',
  fontWeight: '400 !important',
  color: `${theme.vars.palette.grey4} !important`,
  fontSize: '12px !important',
  border: 'none !important',
  lineHeight: '1.2 !important',
  whiteSpace: 'nowrap !important',
}));

export const TableBody = styled('tbody')(() => ({}));
export const TableRow = styled('tr')(() => ({
  backgroundColor: 'white',
  '&:hover': {
    boxShadow: '4px 4px 4px rgba(19, 19, 103, 0.08)',
  },
  '& > td:first-of-type, & > th:first-of-type': {
    borderTopLeftRadius: '3px !important',
    borderBottomLeftRadius: '3px !important',
  },
  '& > td:last-of-type, & > th:last-of-type': {
    borderTopRightRadius: '3px !important',
    borderBottomRightRadius: '3px !important',
  },
}));

export const TableCell = styled('td')(({ theme: { typography, palette } }) => ({
  ...typography['body-small'],
  height: '52px !important',
  paddingLeft: '12px !important',
  paddingRight: '12px !important',
  paddingTop: '8px !important',
  paddingBottom: '8px !important',
  verticalAlign: 'middle',
  color: palette.grey5,
  borderBottom: 'none !important',
}));

export const HighlightedCell = styled('div')(({ theme: { palette } }) => ({
  fontWeight: 500,
  color: palette.black,
}));

export const TableSkeletonCell = styled('td')(() => ({
  padding: '4px !important',
  height: '52px !important',
  border: 'none !important',
}));

export const TableSkeletonRow = styled('tr')(() => ({
  padding: '0px !important',
  height: '52px !important',
  border: 'none !important',
}));
